export default {
  buttons: {
    back: 'Retour',
  },
};
